module.exports = __webpack_public_path__ + "static/media/Florges_gaussian2.8dfcc985.png";